import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs/Subscription';
import { PaymentService } from '../payment/Payment.Services';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {CoronaDialog} from "./corona.component";
declare var CryptoJS: any;
declare var AesUtil: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  lan: string;
  subscription: Subscription;
  constructor(private logger: NGXLogger, private payService: PaymentService,
    private translate: TranslateService, private sharedService: SharedService, private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog) {
  }
  lang: string;
  url: any;
  banner: boolean = true;
  ngOnInit() {
    this.sharedService.refreshData();
    // this.openDialog()
    // var iterationCount = 1000;
    // var keySize = 128;
    // var plaintext = "Hello Rishi";
    // //passPhrase is the key known to server and client...constant value.
    // var passphrase = 'abcdef';

    // var four = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // var salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);

    // var aesUtil = new AesUtil(keySize, iterationCount);
    // var ciphertext = aesUtil.encrypt(salt, four, passphrase, plaintext);
    // var ciphertext2 = aesUtil.decrypt("8bc82ffe516ea1f1b89dcb529a201d56", "ebb7947b5feabdc0b60f2a694fa259c4", "amitsamuel", "");
    // this.logger.debug('ciphertext2 >>'+ciphertext2);


    window.scroll(0, 0);
    this.lang = localStorage.getItem("lang");
    this.logger.debug('language is >>>>>>>>>>>' + this.lang);
    var message = 'amit';
    var key = 'abc123XYZ';


    if (this.lang == "") {
      this.translate.use("ba");
      localStorage.setItem("lang", "ba");
    } else {
      this.translate.use(this.lang);
      localStorage.setItem("lang", this.lang);
    }
  }

  closeBanner(){
    this.banner = false;
  }

  // openDialog(): void {
  //   const dialogRef = this.dialog.open(CoronaDialog, {
  //     width: '450px',
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts